<!--企业获得补贴详情-->
<template>
  <div class="subsidy-container">
    <header-index/>
    <div class="subsidy-content">
      <div class="subsidy-breadcrumb">
        <span>您当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/projectCoach/index' }">政府政策</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/projectCoach/index' }">排行榜</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="subsidy-content-info">
        <div class="subsidy-content-company">
          <p class="subsidy-company">{{ name }}</p>
          <p class="subsidy-gray-span">共获得补贴政策{{ subsidyRankDetail.length }}条</p>
        </div>
        <div class="subsidy-content-list" :style="'min-height:'+min_height+'px;'">
          <div class="subsidy-table" v-if="subsidyRankDetail.length>0">
            <div class="subsidy-th" v-for="item of subsidyRankDetail">
              <p class="subsidy-title">{{ item.title }}</p>
              <p class="subsidy-info">
                <span class="gray-span">公布日期：</span>
                <span class="block-span">{{ item.date }}</span>
                <span class="gray-span">认定单位：</span>
                <span class="block-spans">{{ item.unit }}</span>
                <span class="gray-span">信息来源：</span>
                <span>
                   <el-link type="primary" :underline="false" @click="Reading(item.url)">查看</el-link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import {subsidiesForDetailsList} from '@/api/projectCoach'

export default {
  name: "subsidyRankDetails",
  components: {Hang, Home_footer, HeaderIndex},
  data() {
    return {
      id: 0,
      uid: 0,
      name: '',
      cityList: {},
      childNode: {},
      subsidyRankDetail: [],
      min_height: document.documentElement.clientHeight - 479,
    }
  },
  methods: {
    /*企业获得补贴-补贴详情列表*/
    getSubsidiesForDetailsList() {
      subsidiesForDetailsList({
        cid: this.id,
        uid: this.uid,
        page: 1,
        pageLimit: 20,
      }).then(res => {
        if (res.code == 200) {
          this.subsidyRankDetail = res.content.rows;
        }
      })
    },
    /*查看信息来源*/
    Reading(url) {
      if (url) {
        window.open('https://view.xdocin.com/xdoc?_xdoc=' + url, '_blank')
      } else {
        this.$message({message: '暂无展现内容！', type: 'warning'});
      }
    }
  },
  mounted() {
    this.getSubsidiesForDetailsList();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.uid = this.$route.query.uid;
    this.name = this.$route.query.name;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}

.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}

.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__inner a,
.subsidy-container >>> .subsidy-content .subsidy-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}

.subsidy-container >>> .subsidy-content .subsidy-content-info .subsidy-content-list .subsidy-table .subsidy-info .el-link.el-link--primary {
  color: #1637FF;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.subsidy-container {
  background: #F2F3FB;

  .subsidy-content {
    padding: 10px 18%;
    min-width: 76rem;
    background: #F2F3FB;

    .subsidy-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
    }

    .subsidy-content-info {
      margin-top: 10px;
      background: #FFFFFF;

      .subsidy-content-company {
        padding: 20px;

        .subsidy-company {
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: 500;
          color: #333333;
          margin-block-start: 0px;
          margin-block-end: 0px;
        }

        .subsidy-gray-span {
          font-family: "SourceHanSansCN";
          font-size: 14px;
          font-weight: 500;
          color: #999999;
          margin-block-end: 0px;
        }
      }

      .subsidy-content-list {
        border: 1px solid #F2F3FB;
        padding: 20px;
        border-left: none;
        border-right: none;

        .subsidy-table {
          border-bottom: 1px solid #F2F3FB;
          padding-bottom: 20px;

          .subsidy-th {
            .subsidy-title {
              font-size: 16px;
              font-family: 'SourceHanSansCN';
              font-weight: 500;
              color: #333333;
              margin-block-start: 0px;
              margin-block-end: 0px;
            }

            .subsidy-info {
              margin-block-start: 0px;
              margin-block-end: 0px;
              padding-top: 10px;

              .gray-span {
                color: #999999;
                font-size: 14px;
                font-family: 'SourceHanSansCN';
              }

              .block-span {
                font-size: 14px;
                color: #333333;
                font-family: 'SourceHanSansCN';
                padding-right: 50px;
              }

              .block-spans {
                font-size: 14px;
                color: #333333;
                font-family: "SourceHanSansCN";
                padding-right: 50px;
                min-width: 200px;
                display: -webkit-inline-box;
              }
            }
          }
        }
      }
    }
  }
}
</style>